import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const STATUS = {
  agendado: { label: "Agendado", badge: "bg-sky-50 text-sky-700 border-sky-200", dot: "bg-sky-500", block: "bg-sky-50 border-sky-500 text-sky-900", hex: "#0EA5E9" },
  atrasado: { label: "Atrasado", badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500", block: "bg-amber-50 border-amber-500 text-amber-900", hex: "#F59E0B" },
  faltou: { label: "Faltou", badge: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500", block: "bg-rose-50 border-rose-500 text-rose-900", hex: "#F43F5E" },
  reagendado: { label: "Reagendado", badge: "bg-violet-50 text-violet-700 border-violet-200", dot: "bg-violet-500", block: "bg-violet-50 border-violet-500 text-violet-900", hex: "#8B5CF6" },
  concluido: { label: "Concluído", badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", block: "bg-emerald-50 border-emerald-500 text-emerald-900", hex: "#10B981" },
};
export const STATUS_KEYS = ["agendado", "atrasado", "faltou", "reagendado", "concluido"];

export const CHARGE_STATUS = {
  pago: { label: "Pago", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pendente: { label: "Pendente", badge: "bg-sky-50 text-sky-700 border-sky-200" },
  atrasado: { label: "Em atraso", badge: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const RETURN_STATUS = {
  vencido: { label: "Vencido", badge: "bg-rose-50 text-rose-700 border-rose-200" },
  proximo: { label: "Próximos 30 dias", badge: "bg-amber-50 text-amber-700 border-amber-200" },
  em_dia: { label: "Em dia", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  sem_data: { label: "Sem data", badge: "bg-slate-50 text-slate-600 border-slate-200" },
};

export const CONDITIONS = {
  higido: { label: "Hígido", color: "#FFFFFF" },
  carie: { label: "Cárie", color: "#EF4444" },
  restauracao: { label: "Restauração", color: "#3B82F6" },
  canal: { label: "Canal", color: "#8B5CF6" },
  extraido: { label: "Extraído / Ausente", color: "#64748B" },
  implante: { label: "Implante", color: "#10B981" },
  protese: { label: "Prótese / Coroa", color: "#F59E0B" },
  aparelho: { label: "Aparelho", color: "#06B6D4" },
  clareamento_laser: { label: "Clareamento a laser", color: "#FACC15" },
  clareamento_caseiro: { label: "Clareamento caseiro", color: "#84CC16" },
  protese_superior: { label: "Prótese superior", color: "#F97316" },
  protese_inferior: { label: "Prótese inferior", color: "#EC4899" },
  coroa: { label: "Coroa", color: "#A855F7" },
  pivo: { label: "Pivô", color: "#14B8A6" },
  limpeza_tartaro: { label: "Limpeza de tártaro", color: "#0EA5E9" },
  revisao: { label: "Revisão", color: "#6366F1" },
};

export const METHODS = {
  pix: "PIX",
  credito: "Cartão de Crédito",
  debito: "Cartão de Débito",
  dinheiro: "Dinheiro",
  boleto: "Boleto",
};

export const CATEGORIES = [
  "Avaliação", "Limpeza / Profilaxia", "Restauração", "Endodontia", "Extração", "Ortodontia",
  "Manutenção de aparelho", "Implante", "Prótese", "Clareamento", "Periodontia", "Retorno",
  "Clareamento a laser", "Clareamento caseiro", "Prótese superior", "Prótese inferior", "Coroa", "Pivô", "Limpeza de tártaro", "Revisão", "Outro",
];

export const PROCEDURES = [
  "Avaliação", "Limpeza / Profilaxia", "Restauração", "Endodontia (canal)", "Extração", "Manutenção de aparelho",
  "Instalação de aparelho", "Implante", "Prótese", "Clareamento", "Retorno", "Urgência",
  "Clareamento a laser", "Clareamento caseiro", "Prótese superior", "Prótese inferior", "Coroa", "Pivô", "Limpeza de tártaro", "Revisão", "Outro",
];

export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fmtDate = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "—");

export const fmtLong = (s) => {
  if (!s) return "";
  const t = format(parseISO(s), "EEEE, d 'de' MMMM", { locale: ptBR });
  return t.charAt(0).toUpperCase() + t.slice(1);
};

export const toISO = (d) => format(d, "yyyy-MM-dd");

export const todayISO = () => toISO(new Date());

export const monthLabel = (ym) => format(parseISO(`${ym}-01`), "MMM/yy", { locale: ptBR });

export const age = (birth) => {
  if (!birth) return null;
  const b = parseISO(birth);
  const n = new Date();
  let a = n.getFullYear() - b.getFullYear();
  if (n < new Date(n.getFullYear(), b.getMonth(), b.getDate())) a -= 1;
  return a;
};

export const initials = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const waLink = (phone, text) => {
  let digits = (phone || "").replace(/\D/g, "");
  if (digits.length === 10 || digits.length === 11) digits = `55${digits}`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
};

export const buildTemplates = (s = {}) => {
  const dr = s.dentist_name || "[nome do dentista]";
  const clinic = s.clinic_name || "nosso consultório";
  const pix = s.pix_key || "[chave PIX]";
  return [
    { id: "consulta", label: "Lembrete de consulta", text: `Olá {nome}! Passando para lembrar da sua consulta em {data} às {hora} com ${dr} (${clinic}). Responda 1 para confirmar ou 2 para reagendar.` },
    { id: "mensalidade", label: "Mensalidade do aparelho", text: `Olá {nome}! A mensalidade do seu tratamento ortodôntico no valor de {valor} vence em {vencimento}. Chave PIX para pagamento: ${pix}. Qualquer dúvida estamos à disposição!` },
    { id: "retorno", label: "Lembrete de retorno", text: `Olá {nome}! Está na hora da sua consulta de retorno/revisão em ${clinic}. Vamos agendar um horário que fique bom para você?` },
    { id: "cobranca", label: "Pagamento em aberto", text: `Olá {nome}! Consta em aberto o valor de {valor} referente ao seu tratamento (vencimento {vencimento}). Chave PIX: ${pix}. Se já pagou, por favor desconsidere.` },
    { id: "livre", label: "Mensagem livre", text: "Olá {nome}! " },
  ];
};

export const fillTemplate = (text, vars = {}) =>
  text.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== "" ? vars[k] : m));
